import { useEffect } from 'react';
import { useauthMeQuery, useworkspaceAuthMeV2Query } from '@/types/generated/graphql';
import { setSentryUser } from '@/sentry';

export function useCaptureSentryUser() {
  const { data: userProfile } = useauthMeQuery();
  const { data: workspaceProfile } = useworkspaceAuthMeV2Query();
  const user = userProfile?.authMe?.data?.user;
  const workspaceId = workspaceProfile?.workspaceAuthMeV2?.data?.id;

  useEffect(() => {
    setSentryUser({
      email: user?.email,
      id: user?.id,
      name: user?.name,
      workspaceId,
    });
  }, [user?.email, user?.id, user?.name, workspaceId]);
}
